import React from 'react';
import PropTypes from 'prop-types';
import './FinancialLoader.scss';
import counterpart from 'counterpart';

const FinancialLoader = (props) => {
  return (
    <div className="financial-wrapper">
      <svg
        version="1.1"
        id="CL"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 368 100"
        enableBackground="new 0 0 100 100"
        xmlSpace="preserve"
        style={{ width: props.width }}
      >
        <text x="70" y="21" fontSize="20px" fill={props.fill}>{props.loaderMessage}</text>
        <circle cx="270" cy="22" stroke={props.fill} strokeWidth="1" fill={props.fill} r="2">
          <animate
            attributeName="r"
            begin="0s; circ1b.end"
            dur="0.4s"
            id="circ1a"
            from="2"
            to="0.5"
          />
          <animate
            attributeName="r"
            begin="circ1a.end"
            dur="0.4s"
            id="circ1b"
            from="0.5"
            to="2"
          />
        </circle>
        <circle cx="275" cy="22" stroke={props.fill} strokeWidth="1" fill={props.fill} r="2">
          <animate
            attributeName="r"
            begin="0.1s; circ2b.end"
            dur="0.4s"
            id="circ2a"
            from="2"
            to="0.5"
          />
          <animate
            attributeName="r"
            begin="circ2a.end"
            dur="0.4s"
            id="circ2b"
            from="0.5"
            to="2"
          />
        </circle>
        <circle cx="280" cy="22" stroke={props.fill} strokeWidth="1" fill={props.fill} r="2">
          <animate
            attributeName="r"
            begin="0.2s; circ3b.end"
            dur="0.4s"
            id="circ3a"
            from="2"
            to="0.5"
          />
          <animate
            attributeName="r"
            begin="circ3a.end"
            dur="0.4s"
            id="circ3b"
            from="0.5"
            to="2"
          />
        </circle>
        {props.loaderMessage ? (
			<text x="10" y="40" className="secondary-text-financial">
				<tspan x="10" dy="1.2em" dx="1em">({counterpart("globalTranslate.takeAction.validateTransactionLoaderText1")}</tspan>
				<tspan x="10" dy="1.2em" dx="4em">{counterpart("globalTranslate.takeAction.validateTransactionLoaderText2")})</tspan>
       
			</text>
			) : (
			<text x="30" y="50" className="secondary-text">
			(System is checking for potential duplicate ledger entries.)
			</text>
		)}
      </svg>
    </div>
  );
};

FinancialLoader.propTypes = {
 
 loaderMessage: PropTypes.string,
};
	
	FinancialLoader.defaultProps = {
 
 loaderMessage: '',
  
 };

export default FinancialLoader;
